module.exports = __webpack_public_path__ + "static/media/comment-alt-lines.7eeb780c.svg";